module.exports = __webpack_public_path__ + "static/media/br.ed25a4b6.svg";